'use strict'

import Axios from 'axios'
import { parseResponse, handleError } from '@/_helpers/utils.js'
import qs from 'qs';

export default {
  fetch(params) {
    return new Promise((resolve, reject) => {
      Axios.get('/1.0/responses', {
        params,
        paramsSerializer: params => {
          return qs.stringify(params)
        }
      })
        .then(response => {
          resolve(parseResponse(response))
        })
        .catch(err => reject(handleError(err)))
    })
  },

  fetchSportMasterResponses(params, additionalFiltersQuery) {
    let url = `/1.0/spec-private/sportmaster/responses`;

    if (additionalFiltersQuery.length > 0) {
      url = `/1.0/spec-private/sportmaster/responses?${additionalFiltersQuery}`
    }

    return new Promise((resolve, reject) => {
      Axios.get(url, {
        params,
        paramsSerializer: params => {
          return qs.stringify(params)
        }
      })
        .then(response => {
          resolve(parseResponse(response))
        })
        .catch(err => reject(handleError(err)))
    })
  },

  fetchOne({ id }) {
    return new Promise((resolve, reject) => {
      // Axios.get(`https://private-23df00-usa1706.apiary-mock.com/api/1.0/responses/${id}`)
      Axios.get(`/1.0/responses/${id}`)
        .then(response => {
          resolve(parseResponse(response).data[0])
        })
        .catch(err => reject(handleError(err)))
    })
  },

  fetchCompetences(id) {
    return new Promise((resolve, reject) => {
      Axios.get(`/1.0/responses/${id}/competences`)
        .then(response => {
          resolve(parseResponse(response).data[0])
        })
        .catch(err => reject(handleError(err)))
    })
  },

  fetchComments(id) {
    return new Promise((resolve, reject) => {
      Axios.get(`/1.0/responses/${id}/comments`)
        .then(response => {
          resolve(parseResponse(response).data)
        })
        .catch(err => reject(handleError(err)))
    })
  },

  fetchHistory(id) {
    return new Promise((resolve, reject) => {
      Axios.get(`/v2/responses/${id}/status-history`)
        .then(response => {
          resolve(response.data)
        })
        .catch(err => reject(handleError(err)))
    })
  },

  fetchVoicebot(id) {
    return new Promise((resolve, reject) => {
      Axios.get(`/1.0/responses/${id}/voicebot`)
        .then(response => {
          resolve(parseResponse(response).data[0])
        })
        .catch(err => reject(handleError(err)))
    })
  },

  updateCompetences(id, competences) {
    return new Promise((resolve, reject) => {
      Axios.put(`/1.0/responses/${id}/competences`, { competences })
        .then(response => {
          resolve(parseResponse(response).data[0])
        })
        .catch(err => reject(handleError(err)))
    })
  },

  createComment(id, text) {
    return new Promise((resolve, reject) => {
      Axios.post(`/1.0/responses/${id}/comments`, { comments: [{ message: text }] })
        .then(response => {
          resolve(parseResponse(response).data)
        })
        .catch(err => reject(handleError(err)))
    })
  },

  shareLink(userList) {
    return Axios.post('/1.0/response-links-send', userList)
      .then(response => response)
      .catch(e => Promise.reject(e));
  },

  sendMessage(emails) {
    return new Promise((resolve, reject) => {
      Axios.post('/1.0/response-candidate-emails', emails)
        .then(response => resolve(response))
        .catch(err => reject(handleError(err)))
    })
  },

  updateComment(responseId, commentId, text) {
    const data = { comments: [{ id: commentId, message: text }] }
    return new Promise((resolve, reject) => {
      Axios.put(`/1.0/responses/${responseId}/comments`, data)
        .then(response => {
          resolve(parseResponse(response).data)
        })
        .catch(err => reject(handleError(err)))
    })
  },

  deleteComment(responseId, commentId) {
    return new Promise((resolve, reject) => {
      Axios.delete(`/1.0/responses/${responseId}/comments`, { data: { comments: [{ id: commentId }] } })
        .then(response => {
          resolve(parseResponse(response).data)
        })
        .catch(err => reject(handleError(err)))
    })
  },

  updateStar(id, count) {
    return new Promise((resolve, reject) => {
      Axios.put(
        `/1.0/responses/${id}/stars`,
        { stars: [{ value: count }] },
        { showProgressBar: false }
      ).then(response => resolve(parseResponse(response).data[0]))
        .catch(err => reject(handleError(err)))
    })
  },

  updateOne(model) {
    return new Promise((resolve, reject) => {
      Axios.put('/1.0/responses', { responses: [model] })
        .then(response => {
          resolve(parseResponse(response).data[0])
        })
        .catch(err => reject(handleError(err)))
    })
  },

  updateList(model) {
    return new Promise((resolve, reject) => {
      Axios.put('/1.0/responses', { responses: model })
        .then(response => {
          resolve(parseResponse(response).data[0])
        })
        .catch(err => reject(handleError(err)))
    })
  },

  update(models) {
    return new Promise((resolve, reject) => {
      Axios.put('/1.0/responses', { responses: models })
        .then(response => {
          resolve(parseResponse(response).data)
        })
        .catch(err => reject(handleError(err)))
    })
  },

  remove(models) {
    return new Promise((resolve, reject) => {
      Axios.delete('/1.0/responses', { data: { responses: models.map(model => ({ id: model.id })) } })
        .then(response => {
          resolve()
        })
        .catch(err => reject(handleError(err)))
    })
  },

  xlsExport(params) {
    return new Promise((resolve, reject) => {
      Axios.get('/1.0/responses/report/xls', {
        params,
        paramsSerializer: params => {
          return qs.stringify(params)
        }
      })
        .then(response => {
          resolve(parseResponse(response))
        })
        .catch(err => reject(handleError(err)))
    })
  },

  emailSend(model) {
    return Axios.post(`/1.0/candidate-email`, { email_templates: model })
      .then(response => parseResponse(response))
      .catch(err => handleError(err))
  },

  checkResponsesWithSentTemplate(model) {
    const params = {
      'responses': JSON.stringify(model.responses),
      'templates': JSON.stringify(model.templates)
    }

    return Axios.get(`/1.0/responses/to/response-status-email-template`, {
      params: params
    })
      .then(response => parseResponse(response).data)
      .catch(err => handleError(err))
  }
}
